module.exports = __webpack_public_path__ + "static/soc2-90d4c8325c3d3a357ff0f4442acd1407.png";